export default {
    INSIDE: 'inside',
    OUTSIDE: 'outside',
};